/**
 * Natural Explorer Terrains for Rangers (SRD)
 *
 * Rangers gain the Natural Explorer feature at level 1 and can choose
 * additional terrains at levels 6 and 10.
 */

export interface NaturalTerrain {
  id: string;
  name: string;
  description: string;
}

export const NATURAL_TERRAINS: NaturalTerrain[] = [
  {
    id: 'arctic',
    name: 'Arctic',
    description: 'Frozen tundras, glaciers, and ice fields',
  },
  {
    id: 'coast',
    name: 'Coast',
    description: 'Beaches, shorelines, and coastal regions',
  },
  {
    id: 'desert',
    name: 'Desert',
    description: 'Sandy wastelands and arid environments',
  },
  {
    id: 'forest',
    name: 'Forest',
    description: 'Woodlands, jungles, and dense vegetation',
  },
  {
    id: 'grassland',
    name: 'Grassland',
    description: 'Plains, prairies, and steppes',
  },
  {
    id: 'mountain',
    name: 'Mountain',
    description: 'High peaks, mountain passes, and alpine regions',
  },
  {
    id: 'swamp',
    name: 'Swamp',
    description: 'Marshes, bogs, and wetlands',
  },
  {
    id: 'underdark',
    name: 'Underdark',
    description: 'Subterranean caverns and underground realms',
  },
];

/**
 * Levels at which Rangers can choose additional Natural Explorer terrains
 */
export const NATURAL_EXPLORER_LEVELS = [1, 6, 10];

/**
 * Get terrain count allowed for a given ranger level
 */
export function getNaturalExplorerCount(rangerLevel: number): number {
  let count = 0;
  for (const level of NATURAL_EXPLORER_LEVELS) {
    if (rangerLevel >= level) count++;
  }
  return count;
}

export function getNaturalTerrain(id: string): NaturalTerrain | undefined {
  return NATURAL_TERRAINS.find((t) => t.id === id);
}

export function getNaturalTerrainIds(): string[] {
  return NATURAL_TERRAINS.map((t) => t.id);
}
